<template>
  <img :key="src" :data-src="src || defaultPreview" class="lazyload" />
</template>

<script>
import defaultPreview from '@/../assets/imgs/no-preview.jpg'
export default {
  mounted() {
    this.$emitter.emit('lazyload')
  },
  updated() {
    this.$el?.parentElement?.classList?.remove('lazy-loading')
    this.$el?.parentElement?.classList?.remove('lazy-loaded')
    this.$el?.parentElement?.classList?.remove('lazy-error')
    this.$emitter.emit('lazyload')
  },
  computed: {
    defaultPreview() {
      return defaultPreview
    }
  },
  props: {
    src: String
  }
}
</script>
